import FavoriteFormsList from './FavoriteFormsList';
import SearchFormsPage from './SearchFormsPage';
import ProposeFormPage from './ProposeFormPage';

const path = '/dashboard/my-forms';

const routes = [
  {
    name: 'Forms',
    path: `${path}/list`,
    icon: 'file alternate',
    component: FavoriteFormsList,
    exact: true,
  },
  {
    name: 'Search Forms',
    path: `${path}/search`,
    component: SearchFormsPage,
    hide: true,
    exact: true,
  },
  {
    name: 'Propose Form',
    path: `${path}/propose`,
    component: ProposeFormPage,
    hide: true,
    exact: true,
  },
];

export const redirects = [
  {
    from: path,
    to: `${path}/list`,
  },
  {
    from: `${path}/*`,
    to: `${path}/list`,
  },
];

export default routes;
